/** @jsxImportSource @emotion/react */
import { CollapseComponent } from "../../../../components/CollapseComponent";
import { Collapse } from "antd";
import { UserChallengeHeader } from "./UserChallengeHeader";
import { DetailsRow } from "../../../../components/DetailsRow";
import { css } from "@emotion/react";
import { UserChallenge } from "../../../../service/api-response/Challenges";
import { SpinnerBlock } from "../../../common/Spinner";
import { Placeholder } from "../../../../components/Placeholder";
import { formatDateWithYear } from "../../../../util";

const panelStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

type Props = {
  challenges: UserChallenge[] | undefined;
  isLoading: boolean;
};

export const UserChallengesList = ({ challenges, isLoading }: Props) => {
  if (isLoading) {
    return <SpinnerBlock />;
  }

  if (!challenges || challenges.length === 0) {
    return <Placeholder>User has not started any challenges.</Placeholder>;
  }

  return (
    <CollapseComponent>
      {challenges.map((challenge, index) => (
        <Collapse.Panel
          header={<UserChallengeHeader challenge={challenge} />}
          key={index}
        >
          <div css={panelStyle}>
            <DetailsRow leftText="Reward" rightText={challenge.reward?.title} />
            <DetailsRow
              leftText="Objective goal"
              rightText={challenge.objective_goal.toString()}
            />
            <DetailsRow
              leftText="Objective progress"
              rightText={challenge.objective_progress.toString()}
            />
            <DetailsRow
              leftText="Expiry date"
              rightText={formatDateWithYear(challenge.active_expires_at)}
            />
            <DetailsRow
              leftText="Last reward claim date"
              rightText={formatDateWithYear(challenge.completed_expires_at)}
            />
          </div>
        </Collapse.Panel>
      ))}
    </CollapseComponent>
  );
};
